import ResetPassword from './components/ResetPassword'
import SetPassword from './components/SetPassword'

export default ResetPassword
export {
  SetPassword
}
